import { decodeURISearchPart } from 'httongue';
import { lazyValue } from '@proc7ts/primitives';
import { parseURLRoute } from '../url/url-route.impl.js';
/**
 * @internal
 */
function parseMatrixEntry(raw) {
    const parts = raw.split(';');
    const getAttrs = lazyValue(() => {
        const attrs = new URLSearchParams();
        for (let i = 1; i < parts.length; ++i) {
            const [name, value = ''] = parts[i].split('=');
            attrs.append(decodeURISearchPart(name), decodeURISearchPart(value));
        }
        return attrs;
    });
    return {
        name: decodeURISearchPart(parts[0]),
        raw: raw,
        rawName: parts[0],
        get attrs() {
            return getAttrs();
        },
    };
}
/**
 * Constructs a matrix route by URL.
 *
 * @param url - Source URL. If string given, then URL will be constructed relatively to `route:/` base.
 *
 * @returns New matrix route instance.
 */
export function matrixRoute(url) {
    return parseURLRoute(url, parseMatrixEntry);
}
//# sourceMappingURL=matrix-route.js.map